import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { QuotationRequestModel, VerifyCustomerRequestModel, VerifyVehicleReponseModel } from "@model/quotation.model";
import { ResponseModel } from "@model/api.model";
import { TokenService } from "./token.service";
import { UserModel } from "@model/staff.model";


@Injectable({
    providedIn: "root",
})
export class InsuranceApiService {

      
    constructor(
        private http: HttpClient,
        private tokenService: TokenService
        ) {
    }
    
    GetQuotation(model: QuotationRequestModel): Observable<any> {
        return this.http.post<any>("/Insurance/GetQuotation",model);
    }

    VerifyToken(token: string): Observable<any> {
        return this.http.post<any>("/Insurance/VerifyToken?token="+token,'');
    }

    VerifyVehicleInfo(model: VerifyCustomerRequestModel): Observable<any> {
        return this.http.post<any>("/Insurance/VerifyVehicleInfo", model);
    }

    GetVehicleInfo(referenceNumber: string): Observable<VerifyVehicleReponseModel> {
        return this.http.get<VerifyVehicleReponseModel>("/Insurance/GetVehicleInfo/"+referenceNumber);
    }

    ping(): Observable<ResponseModel<UserModel>> {
        return this.http.get<ResponseModel<UserModel>>(
            '/insurance/ping/'
        );
    }
}
